import { makeAutoObservable } from 'mobx'
import { type Campaign, type ICreateCampaignStep } from 'entities/Campaign'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { CampaignContactsStatisticsTableStore } from 'pages/campaigns/ui/detail/CampaignContactsStatisticsTable'

export class CampaignStepStore {
  private _campaignContactsStatisticsTableStore

  constructor(
    private campaign: Campaign,
    step: ICreateCampaignStep,
    private _entities: IEntitiesStore
  ) {
    this._campaignContactsStatisticsTableStore = new CampaignContactsStatisticsTableStore(
      campaign,
      this._entities,
      step
    )
    makeAutoObservable(this)
  }

  get campaignContactsStatisticsTableStore() {
    return this._campaignContactsStatisticsTableStore
  }

  dispose = () => {
    this._campaignContactsStatisticsTableStore.dispose()
  }

  get total() {
    return this._campaignContactsStatisticsTableStore.total
  }

  get loading() {
    return this._campaignContactsStatisticsTableStore.loading
  }
}
